var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDark)?_c('img',{attrs:{"src":require("@/assets/svgs/logo_orcas_dark.svg"),"height":"60","width":"166"}}):_c('img',{attrs:{"src":require("@/assets/svgs/logo_orcas.svg"),"height":"60"}})}
var staticRenderFns = []

export { render, staticRenderFns }